export function createDefaultAnswer() {
  return {
    id: null,
    answer: "",
    task_labels: [{ id: null, lang_id: 171, content: "", image: "" }],
    correct: false,
  };
}

export function createDefaultTask() {
  return {
    id: null,
    title: "",
    identifier: "",
    domains: [],
    tags: [],
    noTranslationNeeded: false,
    solutions: "",
    languages: [{ id: null, name: "English", task_title: "", content: "" }],
    answer_type: "mcq",
    answer_structure: "default",
    answer_layout: "vertical",
    answer_sorting: "fix",
    image_label: false,
    task_answers: [createDefaultAnswer()],
    grade_difficulty: [{ grade: "", difficulty: "" }],
    tagDetails: [],
    status: "",
  };
}
